import { useRecoilState } from "recoil";
import { viewerState } from "#app/states";

/**
 * 意味あんのか？
 */
export function useViewer() {
	const [viewer, setViewer] = useRecoilState(viewerState);
	return { viewer, setViewer };
}